import { useMemo } from "react";
import Div from "components/primitives/Div";
import Avatar from "components/mui5/Avatar";
import { OrganisationRole } from "types/organisation";
import AthleteHelpers from "helpers/AthleteHelpers";
import CoachHelpers from "helpers/CoachHelpers";
import useMakeProfileImageURL from "hooks/useMakeProfileImageURL";
import useRole from "providers/RoleProvider/useRole";
import { useUserContext } from "hooks";
import { useTranslation } from "react-i18next";

function SettingsAvatar() {
  const { t } = useTranslation();
  const [{ profile }] = useUserContext();
  const role = useRole();

  const profileImagePath = useMemo(() => {
    if (role !== OrganisationRole.COACH) return profile?.profilePhotoName;
    return CoachHelpers.getProfileImagePath(profile);
  }, [profile, role]);

  const photoUrl = useMakeProfileImageURL(profileImagePath);

  const initials = useMemo(() => {
    if (!profile) return "";
    if (role !== OrganisationRole.COACH) return AthleteHelpers.getInitials(profile as any);
    return CoachHelpers.getInitials(profile);
  }, [profile, role]);

  return (
    <Div>
      <Avatar
        src={photoUrl || undefined}
        alt={t("global.profile_avatar_label")}
        sx={(theme) => ({
          height: theme.spacing(4),
          width: theme.spacing(4),
          borderRadius: "8px",
        })}
      >
        {initials}
      </Avatar>
    </Div>
  );
}

export default SettingsAvatar;
